import videojs from 'video.js';

const _existingLayout = new WeakMap();

/**
 * Gets a reference to the main layout container within the player. Most child components added by plugins should be inserted here.
 * @memberof MediasitePlayer#
 * @returns {videojs.Component}
 * @example
 * player.layout().addChild(someCustomVideoJsComponent);
 */
function layout() {
    let existingLayout = _existingLayout.get(this);
    if (!existingLayout) {
        const Component = videojs.getComponent('Component');
        existingLayout = new Component(this);
        existingLayout.addClass('mediasite-player__layout');
        _existingLayout.set(this, existingLayout);

        // Video element gets special treatment in iOS from Video.js and lives at index 0. Attempting to use 0 causes errors in Safari.
        this.ready(() => this.addChild(existingLayout, {}, 1));
    }
    return existingLayout;
}

export default layout;
